'use strict';
import './mx-dependency-visualizer.js';

angular.module('mx.SolutionBuilderAgent').component('mxDependencyVisualizerLazy', {
	bindings: { dependencyTree: '<', currentObject: '=?' },
	controller: MxDependencyVisualizerLazyCtrl,
	controllerAs: 'vm',
	template:
		'<div oc-lazy-load="ngVis"><mx-dependency-visualizer dependency-tree="vm.dependencyTree" on-node-click="vm.currentObject = object" class="mx-control--avoid-hiding"></mx-dependency-visualizer></div>',
});

MxDependencyVisualizerLazyCtrl.$inject = ['$ocLazyLoad', 'mx.components.LazyLoadCfg', 'mx.shell.Config'];
function MxDependencyVisualizerLazyCtrl($ocLazyLoad, lazyLoadCfg, mxConfig) {
	const anticache = `?anticache=${mxConfig.settings.productVersion}`;

	$ocLazyLoad.setModuleConfig({
		name: 'ngVis',
		serie: true,
		files: [
			`${lazyLoadCfg.componentsDir}vis/dist/vis.min.css${anticache}`,
			`${lazyLoadCfg.componentsDir}vis/dist/vis.min.js${anticache}`,
			`${lazyLoadCfg.componentsDir}angular-visjs/angular-vis.js${anticache}`,
		],
	});
}
